import React from 'react';
import './Maintenance.css';

export default function Maintenance({ message, siteName, siteTagline }) {
  const name = siteName || 'Casa Eden';
  const tagline = siteTagline || 'Pensiune la malul mării';

  return (
    <div className="maintenance-page">
      <div className="maintenance-page__logo">🌊</div>
      <h1 className="maintenance-page__title">{name}</h1>
      <p className="maintenance-page__subtitle">{tagline}</p>

      <div className="maintenance-page__card">
        <div className="maintenance-page__icon">🔧</div>
        <h2>Mentenanță în curs</h2>
        <p className="maintenance-page__message">
          {message || 'Site-ul este momentan în mentenanță. Revenim în curând!'}
        </p>
      </div>

      <p className="maintenance-page__footer">
        &copy; {new Date().getFullYear()} {name}
      </p>
    </div>
  );
}
